<div @fadeS class="container-security">
    <header class="header">
        <div class="container-logo">
            <div class="logo">
                <img src="./assets/temporals/Logo_Akana_Azul.png" (click)="goToUrl('home')" alt="">
            </div>
            <div class="faqs" (click)="goToUrl('faqs')">
                <p>{{'FAQS.NAME' | translate}}&nbsp;&nbsp;&nbsp;</p><img src="./assets/logos/faq.svg" alt="">
            </div>
        </div>
    </header>
    <div class="sub-tittle">
        <app-security-banner [button]="true"></app-security-banner>
        <h2 id="tittle">¿Están seguros mis datos en Akana?</h2>
    </div>
    <div class="left">
        <div class="icon-text-container last">
            <img style="margin-bottom: 5px;" src="./assets/home/security/lock.svg" alt="">
            <h3>Seguridad de Akana</h3>
            <p class="text-information">
                Akana es un servicio de información de cuentas ofrecido por Santander Consumer Finance, entidad regulada
                por Banco de España y que cumple con los requerimientos de la directiva europea PSD2.
                Es un servicio gratuito, que pretende mostrar los datos con trasparencia y claridad, y que cuenta con la
                garantía de una compañía del grupo Santander.
            </p>
        </div>
        <div class="icon-text-container">
            <img style="margin-bottom: 20px;" src="./assets/home/security/paper.svg" alt="">
            <h3>¿Qué pasa con tus datos?</h3>
            <p class="text-information">
                En Akana cumplimos con todos los requerimientos establecidos por el Reglamento General de Protección de
                Datos (RGPD): <br>
                - Solo trataremos tus datos para los fines informados en la Política de Privacidad.<br>
                - Tus datos, en especial los que visualicemos en tu cuenta, son confidenciales. Estos no se comparten
                con terceros ni llegamos a acuerdos comerciales para beneficiarnos de ellos.<br>
                - Puedes solicitar el borrado de tus datos en cualquier momento.<br>
                Más información en la <a class="go" (click)="goToUrl('privacy-polity')">Política de Privacidad</a>.

            </p>
        </div>
    </div>
    <div class="right">
        <div class="icon-text-container last">
            <img src="./assets/home/security/directory.svg" alt="">
            <h3>Akana no almacena tus claves</h3>
            <p class="text-information">
                Gracias a la directiva PSD2, tu banco está obligado a facilitar que compartas la información de tu
                cuenta con quien tú desees y de forma segura.
                Por ese motivo debemos cumplir los requerimientos de acceso de tu banco, introduciendo claves o mediante
                los mecanismos que tu banco haya puesto a tu disposición para identificarte.
                En ningún caso esas claves son almacenadas o gestionadas por Akana.
            </p>
        </div>
        <div class="icon-text-container">
            <img width="150px" src="./assets/home/security/password.png" alt="">
            <h3>Sistema encriptado</h3>
            <p class="text-information">
                Akana es una web segura, que dispone de los estándares de seguridad más avanzados.
                Como prestadores de servicios digitales, operamos con certificados eIDAS exigidos por la normativa
                europea.
                Todas nuestras comunicaciones se producen utilizando protocolos de encriptación RSA sobre TLS.
            </p>
        </div>
    </div>
    <div class="polity">
        <div class="polity-button">
            <h2 id="tittle">
                Política de privacidad
            </h2>
            <p>
                La transparencia es uno de nuestros valores principales. <br>
                Por eso, aquí puedes ver nuestra política de privacidad al <br> completo.
            </p>
            <img (click)="goToUrl('privacy-polity')" src="./assets/home/security/button.png" alt="">
        </div>
        <img class="semi" src="./assets/home/security/semi-circle.png" alt="">
    </div>
    <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>